export default __webpack_public_path__ + "static/media/ic_gmx_custom_ (2).b5ae559f.svg";